import { render, staticRenderFns } from "./productCreate3Q.vue?vue&type=template&id=2f297d12&scoped=true&"
import script from "./productCreate3Q.vue?vue&type=script&lang=js&"
export * from "./productCreate3Q.vue?vue&type=script&lang=js&"
import style1 from "./productCreate3Q.vue?vue&type=style&index=1&lang=css&"
import style2 from "./productCreate3Q.vue?vue&type=style&index=2&id=2f297d12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f297d12",
  null
  
)

export default component.exports